import React, { useState, useEffect } from "react";
import {
    Center,
    Grid,
    GridItem,
    Text,
    Skeleton,
    Card,
    CardBody
} from "@chakra-ui/react";
import ReactSpeedometer from "react-d3-speedometer";
import moment from "moment";

const GaugeReport = ({ startDate, endDate, targets, totalPotentialCount }) => {
    const [totalTarget, setTotalTarget] = useState(0);
    const [guageValue, setGuageValue] = useState(0);
    const gaugeStyle = {
        veryLow: '#fc0000',
        low: '#fca532',
        average: '#c7fc53',
        high: '#92f745',
        veryHigh: '#63bd51'
    };
    const gridStyle = {
        h: '8',
        w: '100%',
        padding: '5px'
    };
    const textStyle = {
        align: 'center'
    };

    useEffect(() => {
        setTotalTarget(targets.reduce((previous, current) => (previous + Number(current.targetr)), 0));
        let potentitialCalculation = (totalTarget / (moment(endDate).diff(moment(startDate), 'days') + 1)) * (moment().diff(moment(startDate), 'days') + 1);
        let percentage = Math.round((Number(totalPotentialCount) / potentitialCalculation) * 100);
        setGuageValue(percentage < 201 ? percentage : 200);
    }, [targets, totalTarget, totalPotentialCount, startDate, endDate]);

    return (
        <Card
            direction={{ base: 'column', sm: 'row' }}
            overflow='hidden'
            variant='outline'
            align='center'
            borderRadius={10}
            marginX={{ base: '5px', sm: '0px', md: '5px', lg: '5px' }}
        >
            <CardBody>
                <Skeleton fadeDuration={5} height='400px' isLoaded={targets && totalPotentialCount}>
                    <Center>
                        <ReactSpeedometer
                            maxValue={200}
                            value={guageValue}
                            segments={5}
                            maxSegmentLabels={0}
                            segmentColors={Object.values(gaugeStyle)}
                            currentValueText={`${guageValue}%`}
                            needleColor="black"
                            ringWidth={35}
                            forceRender={true}
                        />
                    </Center>
                    <Center marginTop='-100px'>
                        <Grid
                            templateColumns='repeat(2, 1fr)'
                            templateRows='repeat(2, 1fr)'
                            gap={0}
                        >
                            <GridItem {...gridStyle}>
                                <Text>Target</Text>
                            </GridItem>
                            <GridItem {...gridStyle}>
                                <Text {...textStyle}>{totalTarget}</Text>
                            </GridItem>
                            <GridItem {...gridStyle}>
                                <Text>Very Low</Text>
                            </GridItem>
                            <GridItem {...gridStyle} bg={gaugeStyle.veryLow}>
                                <Text {...textStyle}>0% - 40%</Text>
                            </GridItem>
                            <GridItem {...gridStyle}>
                                <Text>Low</Text>
                            </GridItem>
                            <GridItem {...gridStyle} bg={gaugeStyle.low}>
                                <Text {...textStyle}>41% - 80%</Text>
                            </GridItem>
                            <GridItem {...gridStyle}>
                                <Text>Average</Text>
                            </GridItem>
                            <GridItem {...gridStyle} bg={gaugeStyle.average}>
                                <Text {...textStyle}>81% - 120%</Text>
                            </GridItem>
                            <GridItem {...gridStyle}>
                                <Text>High</Text>
                            </GridItem>
                            <GridItem {...gridStyle} bg={gaugeStyle.high}>
                                <Text {...textStyle}>121% - 160%</Text>
                            </GridItem>
                            <GridItem {...gridStyle}>
                                <Text>Very High</Text>
                            </GridItem>
                            <GridItem {...gridStyle} bg={gaugeStyle.veryHigh}>
                                <Text {...textStyle}>161% - 200%</Text>
                            </GridItem>
                        </Grid>
                    </Center>
                </Skeleton>
            </CardBody>
        </Card>
    );
};

export default GaugeReport;